import React, { Fragment } from 'react';
import { useTranslation } from "react-i18next";
import Events from '../../api/events';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

const EventPage = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main">
                <section className="events sitePageSection">
                    <div className="container">
                        <div className="sitePageHeading">
                            <h1>{t("events.page_title")}</h1>
                        </div>
                        <div className="row">
                            {Events.map((event, et) => (
                                <div className="col-12 mb-30" key={et}>
                                    <div className="eventsBlock">
                                        <figure className="eventsBlock__thumb">
                                            <img src={event.eImg} alt={t(event.title)} className="eventsBlock__thumb__image" />
                                        </figure>
                                        <div className="eventsBlock__content">
                                            <div className="eventsBlock__date">
                                                <span className="eventsBlock__dateLabel">{t("events.date_label") || "Tarih:"}</span>
                                                <span>{t(event.date)}</span>
                                            </div>
                                            <h3 className="eventsBlock__heading">
                                                {t(event.title)}
                                            </h3>
                                            <p className="eventsBlock__text">{t(event.description)}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default EventPage;
